import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import MenuOptions from "./MenuOptions";

export default function SideDrawer(props: any) {
  const { showDrawer, setShowDrawer, setShowDialog } = props;
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobileView = useMediaQuery(theme.breakpoints.down("md"));
  const location = useLocation();
  const { pathname } = location;
  const { authReducer, userReducer }: any = useAppSelector((state) => state);
  const { userProfile } = userReducer;
  const {
    isLoggedIn,
    loginState = { displayName: "", pic: "", email: "" },
    isLoadingAuth,
  } = authReducer;
  const { displayName, pic, email } = loginState;
  const dispatch = useAppDispatch();



  const linkClickHandler = (path: string) => {
    navigate(path);
    showDrawer && setShowDrawer(false);
  };

  React.useEffect(() => {
    if (!isMobileView) setShowDrawer(false);
  }, [isMobileView, setShowDrawer]);

  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setShowDrawer(open);
    };

  const ListEl = () => (
    <Box
      sx={{ width: "100%" }}
      role="presentation"
      onClick={() => toggleDrawer(false)}
      onKeyDown={() => toggleDrawer(false)}
    >
      
      <MenuOptions setShowDialog={setShowDialog}
        displayName={userProfile?.name || displayName}
        pic={userProfile?.image_url || pic}
        email={userProfile?.email || email}
        isLoggedIn={isLoggedIn}
        onClose={() => {
          setShowDrawer(false);
        }}
      />
      {/* <List>
        {isLoggedIn && displayName && (
          <React.Fragment>
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <Avatar alt={displayName} src={pic} />
                </ListItemIcon>
                <ListItemText
                  primary={displayName}
                  secondary={email}
                  primaryTypographyProps={{
                    color: "primary",
                    textTransform: "uppercase",
                    fontWeight: 500,
                  }}
                />
              </ListItemButton>
            </ListItem>

            <Divider />
          </React.Fragment>
        )}

        {links.map(
          ({ label, Icon, path, hideFromHeader }: any, index: number) => (
            <ListItem
              key={label}
              disablePadding
              sx={{
                backgroundColor:
                  path == pathname ? "primary.main" : "transparent",
              }}
            >
              <ListItemButton onClick={() => linkClickHandler(path)}>
                <ListItemIcon>
                  <Icon
                    sx={{
                      color:
                        path == pathname ? "common.white" : "header.links.main",
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={label}
                  primaryTypographyProps={{
                    color:
                      path == pathname ? "common.white" : "header.links.main",
                  }}
                />
              </ListItemButton>
            </ListItem>
          )
        )}
      </List>
      <Box sx={{ px: "10px" }}>
        <RentalOwnerTabs onClose={() => toggleDrawer(false)} />
      </Box>
      <Divider />
      <List>
        {!isLoggedIn &&
          authLinks.map(({ label, Icon, path }: any, index: number) => (
            <ListItem
              key={label}
              disablePadding
              sx={{
                backgroundColor:
                  path == pathname ? "primary.main" : "transparent",
              }}
            >
              <ListItemButton onClick={() => linkClickHandler(path)}>
                <ListItemIcon>
                  <Icon
                    sx={{
                      color:
                        path == pathname ? "common.white" : "header.links.main",
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={label}
                  primaryTypographyProps={{
                    color:
                      path == pathname ? "common.white" : "header.links.main",
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}

        <TabPills tabIndex={tabIndex} setTabIndex={setTabIndex} />

        {isLoggedIn && displayName && (
          <ListItem disablePadding>
            <ListItemButton onClick={() => navigate("/logout")}>
              <ListItemIcon>
                <LogoutIcon />
              </ListItemIcon>
              <ListItemText primary={"Logout"} />
            </ListItemButton>
          </ListItem>
        )}
      </List>
 
      {isLoggedIn && (
        <Box sx={{ p: 2 }}>
          <Button
            key={"ListTractorBtn"}
            fullWidth
            onClick={() => navigate("/list-equipment")}
            sx={{
              backgroundColor: "primary.main",
              color: "white",
              display: "block",
              fontSize: "15px",
              fontWeight: 500,
              "&:hover": {
                backgroundColor: "primary.main",
                color: "white",
              },
            }}
          >
            List Your Equipment
          </Button>
        </Box>
      )} */}
    </Box>
  );

  return (
    <div>
      <React.Fragment key={"right"}>
        <Drawer
          anchor={"right"}
          open={showDrawer}
          onClose={() => setShowDrawer(false)}
        >
          <ListEl />
        </Drawer>
      </React.Fragment>
    </div>
  );
}
